import React from "react";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4 text-white">MRautomotores</h3>
            <p className="text-slate-400">
              Es una concesionaria de autos nuevos y usados en Córdoba,
              especializada en la venta de vehículos seleccionados al mejor
              precio. Ofrecemos autos usados con financiación, entrega inmediata
              y asesoramiento personalizado para que encuentres el vehículo
              ideal.
            </p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="/"
                  className="text-slate-400 hover:text-sky-400 transition-colors"
                >
                  Inicio
                </a>
              </li>
              <li>
                <a
                  href="/catalogo"
                  className="text-slate-400 hover:text-sky-400 transition-colors"
                >
                  Catálogo
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-slate-400 hover:text-sky-400 transition-colors"
                >
                  Contacto
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Contacto</h4>
            <ul className="space-y-2 text-slate-400">
              <li>Teléfono: +54 9 3512161967</li>
              <li>Córdoba, Argentina</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-800 mt-8 pt-8 text-center text-slate-400">
          <p>&copy; 2026 MR Automotores. Todos los derechos reservados. Venta de autos en Argentina.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
